<template>
  <div>
    <!-- 新增标签编辑弹框 -->
    <el-dialog
      custom-class="tag-edit-dialog"
      :title="$t('message.labelEditing')"
      :visible.sync="dialogVisible"
      width="560px"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-form label-width="110px" class="tag-form">
        <el-form-item :label="$t('message.labelType')" required>
          <el-select v-model="form.type" :placeholder="$t('message.pleaseSelectLabelType')">
            <el-option v-for="item in tagList" :key="item.type" :label="item.remark" :value="item.type" />
          </el-select>
        </el-form-item>

        <div class="form-row">
          <el-form-item :label="$t('message.labelNumber')" required>
            <el-input v-model="form.no" :placeholder="$t('message.pleaseEnterLabelNumber')" />
          </el-form-item>
          <el-form-item :label="$t('message.encodingFormat')" label-width="70px" class="code-type">
            <el-select v-model="form.code_type">
              <el-option v-for="item in codeTypeList" :key="item" :label="item" :value="item" />
            </el-select>
          </el-form-item>
        </div>

        <el-form-item :label="$t('message.commodityManagementCode')">
          <el-input v-model="form.goods_no" :placeholder="$t('message.pleaseEnterCommodityCode')" />
        </el-form-item>

        <el-form-item v-for="(item, index) in textLineList" :key="item" :label="$t('message.labelText') + '（' + (index + 1) + '）'">
          <el-input v-model="form[item]" :placeholder="$t('message.pleaseEnterLabelText')" />
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button class="preview-button" @click="preview">
          <i class="el-icon-printer"></i>
          {{ $t('message.preview') }}
        </el-button>
        <el-button type="primary" @click="save">{{ $t('message.save') }}</el-button>
      </span>
    </el-dialog>

    <!-- 复用配送单详情标签打印组件，调用浏览器打印预览 -->
    <div v-show="false">
      <div v-if="printTagData" ref="tabPrint">
        <tab-print :print-tag-data="printTagData" :is-express="''" />
      </div>
    </div>
  </div>
</template>

<script>
import TabPrint from '@/components/Printedsheet/tag/tabPrint.vue'

export default {
  name: 'TagEditDialog',
  components: { TabPrint },
  props: {
    tagList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      dialogVisible: false,
      editIndex: null,
      printTagData: null,
      codeTypeList: ['CODE128', 'EN13', 'CODE39', 'EN8'],
      textLineList: ['text_line_one', 'text_line_two', 'text_line_three', 'text_line_four'],
      form: {}
    }
  },
  methods: {
    // 打开弹框时创建一条新的标签数据。
    open() {
      this.editIndex = null
      this.form = {
        type: '',
        no: '',
        goods_no: '',
        code_type: 'CODE128',
        text_line_one: '',
        text_line_two: '',
        text_line_three: '',
        text_line_four: ''
      }
      this.dialogVisible = true
    },
    // 编辑时复制标签，弹框输入不会实时修改列表。
    edit(tag, index) {
      this.editIndex = index
      this.form = JSON.parse(JSON.stringify(tag))
      this.dialogVisible = true
    },
    // 使用配送单详情相同的标签组件打开打印预览。
    preview() {
      if (!this.form.no) return this.$message.error(this.$t('message.pleaseEnterLabelNumber'))
      this.printTag(this.form)
    },
    printTag(tag) {
      this.printTagData = tag
      this.$nextTick(() => {
        this.$print(this.$refs.tabPrint)
        this.printTagData = null
      })
    },
    // 校验必填项后，将标签原始字段交给创建方案弹框。
    save() {
      if (!this.form.type) return this.$message.error(this.$t('message.pleaseSelectLabelType'))
      if (!this.form.no) return this.$message.error(this.$t('message.pleaseEnterLabelNumber'))
      this.$emit('save', this.form, this.editIndex)
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.tag-form {
  padding: 4px 22px 0 0;

  /deep/ .el-form-item {
    margin-bottom: 18px;
  }

  /deep/ .el-select {
    width: 100%;
  }
}

.form-row {
  display: flex;

  /deep/ .el-form-item:first-child {
    flex: 1;
  }

  .code-type {
    flex: 0 0 190px;
    margin-left: 10px;
  }
}

.dialog-footer {
  display: flex;
  justify-content: center;

  .preview-button {
    color: #315EDE;
    border-color: #315EDE;
  }

  .el-button--primary {
    background: #B4272D;
    border-color: #B4272D;
  }
}
</style>

<style lang="scss">
.tag-edit-dialog {
  .el-dialog__body {
    padding: 18px 20px 4px;
  }

  .el-dialog__footer {
    padding-bottom: 24px;
  }
}
</style>
